import React, { useState, useEffect } from 'react';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import classNames from 'classnames';
import EditableSection from 'components/v2/EditableSection';
import Select from 'components/v2/select';
import { Translation, useTranslation } from 'react-i18next';
import {
  checkPermissonForEditShipperBillingModule,
  payloadMappingOnlyForChanges,
} from '../utils';

const scheduleOptions = [
  { slug: 'individual', localizationSlug: 'INDIVIDUAL' },
  { slug: 'daily', localizationSlug: 'DAILY' },
  { slug: 'weekly', localizationSlug: 'WEEKLY' },
];

const scheduleInfo = (
  <Translation>
    {(t) => (
      <div>
        <div> {t('INVOICE_SCHEDULE_TOOLTIP_INDIVIDUAL')} </div>
        <div> {t('INVOICE_SCHEDULE_TOOLTIP_DAILY')} </div>
        <div> {t('INVOICE_SCHEDULE_TOOLTIP_WEEKLY')} </div>
      </div>
    )}
  </Translation>
);

const ShorthaulInvoiceSettingsSummary = ({ fields = {} }) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 gap-4">
      <DescriptionListItem
        label={t('INVOICE_SCHEDULE')}
        className=""
        info={scheduleInfo}
      >
        {t(
          scheduleOptions.find((o) => o.slug === fields?.invoice_schedule)
            ?.localizationSlug || '',
        )}
      </DescriptionListItem>
    </div>
  );
};

const ShorthaulInvoiceSettingsForm = ({
  fields,
  onChange,
  saving,
  onSaveShipper,
  onSaveSuccess,
  onSaveFail,
}) => {
  const { t } = useTranslation();

  const saveForm = async () => {
    try {
      await onSaveShipper();
      onSaveSuccess(fields);
    } catch (e) {
      onSaveFail();
    }
  };

  useEffect(() => {
    if (saving) {
      saveForm();
    }
  }, [saving]);

  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <Select
          label={t('INVOICE_SCHEDULE')}
          items={scheduleOptions}
          info={scheduleInfo}
          valueKey="slug"
          textKey="localizationSlug"
          selected={fields.invoice_schedule}
          onSelect={({ slug }) => onChange('invoice_schedule', slug)}
        />
      </div>
    </div>
  );
};

const ShorthaulInvoiceSettings = ({ data, className, onUpdateShipper }) => {
  const [initialData, setInitialData] = useState(data);
  const [shorthaulInvoiceSettingsData, setShorthaulInvoiceSettingsData] =
    useState(data);
  const { t } = useTranslation();

  const onChange = (field, value) => {
    setShorthaulInvoiceSettingsData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    const payload = payloadMappingOnlyForChanges(
      initialData,
      shorthaulInvoiceSettingsData,
    );
    if (Object.keys(payload).length) {
      await onUpdateShipper(payload);
    }
  };

  const handleAfterSave = (onSaveSuccess) => {
    return (updatedData = {}) => {
      setInitialData((prev) => ({ ...prev, ...updatedData }));
      onSaveSuccess();
    };
  };

  return (
    <EditableSection
      title={t('INVOICE')}
      className={classNames(className)}
      canEdit={checkPermissonForEditShipperBillingModule()}
    >
      {(editing, saving, onSaveSuccess, onSaveFail) => (
        <>
          {!editing && <ShorthaulInvoiceSettingsSummary fields={initialData} />}
          {editing && (
            <ShorthaulInvoiceSettingsForm
              fields={shorthaulInvoiceSettingsData}
              onChange={onChange}
              onSaveShipper={() => handleSave()}
              saving={saving}
              onSaveSuccess={handleAfterSave(onSaveSuccess)}
              onSaveFail={onSaveFail}
            />
          )}
        </>
      )}
    </EditableSection>
  );
};

export default ShorthaulInvoiceSettings;
